// SkyQuest Freshling Card configuration.
// Update these URLs and formations for your event.

export const SKYQUEST_LOGOS = {
  // Cloud-storage URL for the SkyQuest logo (left logo on card)
  skyQuestLogoUrl: '',
  // Cloud-storage URL for the Fresh Meet logo (right logo on card)
  freshMeetLogoUrl: '',
};

// Formation pool for SkyQuest cards.
// Each entry should provide the display name (all caps) and a formation diagram image URL.
// Example:
// { id: 'phalanx', formationName: 'PHALANX', formationImageUrl: 'https://...' }
export const SKYQUEST_FORMATIONS = [
  // Fill with your formation types.
];

